import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { PdfViewerService } from '../../pdf-viewer.service';
import { IPdfDocument } from '../../types';
import { PdfThumbnailViewportsContainerService } from './pdf-thumbnail-viewports-container.service';

@Component({
  selector: 'ss-pdf-thumbnail-viewports-container',
  templateUrl: './pdf-thumbnail-viewports-container.component.html',
  styleUrls: ['./pdf-thumbnail-viewports-container.component.css'],
  providers: [
    PdfThumbnailViewportsContainerService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfThumbnailViewportsContainerComponent implements OnInit, AfterViewInit {

  private readonly _destroy = new Subject<void>()

  @ViewChild('thumbnailScroller')
  private _thumbnailScroller: ElementRef<HTMLDivElement>


  readonly thumbnailScrollerSubject = this._pdfThumbnailViewportsContainerService.thumbnailScrollerSubject;
  // readonly pdfDocumentsSubject = this._pdfThumbnailViewportsContainerService.pdfDocumentsSubject;
  readonly pdfDocumentInputsSubject = this._pdfViewerService.pdfDocumentInputsSubject;
  readonly scrollTopSubject = this._pdfThumbnailViewportsContainerService.scrollTopSubject;

  constructor(
    private readonly _pdfViewerService: PdfViewerService,
    private _pdfThumbnailViewportsContainerService: PdfThumbnailViewportsContainerService
  ) {

  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {

    // this._pdfThumbnailViewportsContainerService.virtualScrollableSubject.next(this._virtualScrollingElement);
    this.thumbnailScrollerSubject.next(this._thumbnailScroller.nativeElement)

  }

  trackById(idx: number, pdfDocument: IPdfDocument) {

    return pdfDocument.id;
  }



  ngOnDestroy() {
    this._destroy.next()
    this._destroy.complete()
  }
}
